module.exports = __webpack_public_path__ + "img/atividade.760fa191.png";